import { ElementProps } from '@/types/elements';
import { Transition } from '@headlessui/react';
import clsx from 'clsx';
import { useState } from 'react';

export default function CollapsibleTextElement({ block: { id: blockId, data }, viewMode, tracer, appearance }: ElementProps) {
    const { title, body } = data;
    const [expanded, setExpanded] = useState(false);
    const onClick = () => {
        // if (mode == ElementMode.VIEW) openLink({ blockId, link, siteId, pageId, meta: {} })
    }
    return (
        <div
            className={clsx("inline-flex flex-col w-full text-gray-800 duration-1000 ease-in-out transform rounded-xl", appearance?.corner === 'square' ? 'rounded-none' : 'rounded-lg')}>

            <div className="flex items-center justify-start space-x-3 cursor-pointer" onClick={() => setExpanded((v) => !v)}>
                <div className="">
                    <svg className={clsx("origin-center fill-gray-800 stroke-gray-600 transition duration-500", expanded ? "rotate-0" : "-rotate-90")} width={12} height={12} version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="-1.5 -1.5 13 13"><polygon points="0,0 10,0 5,10" stroke-linejoin="round" stroke-width="1.5"></polygon></svg>
                </div>
                <p className="text-gray-600 font-Inter text-md">{title}</p>
            </div>
            
            <Transition
                show={expanded}
                className="w-full space-x-6 text-left"
                enter="transition-opacity duration-500 ease-in"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="transition-opacity duration-250 ease-out"
                leaveFrom="opacity-100"
                leaveTo="opacity-0">
                    <div></div>
                <div className="py-2 text-sm text-gray-800 rounded-md text-body font-Inter md:text-md" dangerouslySetInnerHTML={{ __html: body }}></div>
            </Transition>
        </div>
    )
}
